import * as Sentry from '@sentry/react'
import { Integrations } from "@sentry/tracing"
import { graphql, useStaticQuery } from "gatsby"
// import jwt from 'jsonwebtoken';
import jwt_decode from "jwt-decode"
import React, { useEffect, useState } from "react"
import Cookies from 'universal-cookie'
import TransversalServices from '../../../services/transversal-services'
import { localStorage } from '../../../utils/storage'
import QuickAccessMenu from "../../atoms/quick-access-menu/quick-access-menu"
import ChatModal from '../../molecules/chat-modal/chat-modal'
import CookiesToast from '../../molecules/cookies-toast/cookies-toast'
import Footer from "../../molecules/footer/footer"
import Header from "../../molecules/header/header"
import PWAInstallationModal from '../../molecules/pwa-installation-modal/pwa-installation-modal'
import ShoppingModal from "../../molecules/shopping-modal/shopping-modal"
import "./layout.scss"
import Query from "./query"
// var jwt = require('jsonwebtoken')


const Layout = props => {

  Sentry.init({ integrations: [new Integrations.BrowserTracing()] });

  const { children, activeMenu } = props;
  const [activeShoppingModal, setActiveShoppingModal] = useState(false);
  // const [activeCookiesToast, setActiveCookiesToast] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  const resultQuery = Query()

  const articles = resultQuery.allContentfulPequeninArticulos.nodes.filter(e => e.node_locale === process.env.LOCALE)

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  // useEffect(() => {
  //   const cookies = new Cookies();
  //   const cookiesAccepted = cookies.get('cookiesAccepted');
  //   if (!cookiesAccepted) {
  //     setActiveCookiesToast(true)
  //   }
  // }, []);

  const launchPWA = () => {
    window.addEventListener("beforeinstallprompt", e => {

      e.preventDefault()

      const pwaVisualization = localStorage.getItem("PWA_VISUALIZATION")
      if (pwaVisualization || pwaVisualization === 0) {
        if (pwaVisualization !== "denied") {
          setActiveModal(
            <PWAInstallationModal
              deferredPrompt={e}
              setActiveModal={setActiveModal}
            />
          )
        }
      } else {
        localStorage.setItem("PWA_VISUALIZATION", 0)
        setActiveModal(
          <PWAInstallationModal
            deferredPrompt={e}
            setActiveModal={setActiveModal}
          />
        )
      }
    })

  }

  const launchPWAIOS = () => {
    const pwaVisualization = localStorage.getItem("PWA_VISUALIZATION")
    if (pwaVisualization || pwaVisualization === 0) {
      if (pwaVisualization !== "denied") {
        setActiveModal(
          <PWAInstallationModal
            setActiveModal={setActiveModal}
          />
        )
      }
    } else {
      localStorage.setItem("PWA_VISUALIZATION", 0)
      setActiveModal(
        <PWAInstallationModal
          setActiveModal={setActiveModal}
        />
      )
    }


  }

  const monthNames = ["Enero", "Feb.", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Ago.", "Sep.", "Oct.", "Nov.", "Dic."];
  const formatDate = (date) => {
    var dateForm = new Date(date)
    return dateForm.getDate() + " de " + monthNames[dateForm.getMonth()]
  };

  const handleLoadArticlesSaved = () => {
    const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
    if (tokenInfo) {
      try {
        let decodedJwt = jwt_decode(tokenInfo.idToken);

        if (decodedJwt) {
          let encodedString = btoa(decodedJwt.email.toString());
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'authentication',
            'userId': encodedString
          });
        }
      } catch (e) {
        console.error("Decode Error", e);
      }

      let config = {
        headers: {
          Authorization: tokenInfo.idToken,
        },
      }

      TransversalServices.getAllArticle(config)
        .then(res => {
          if (res.status === 200) {
            let newListArticlesSaved = []
            res.data.map(art => {
              let tempArt = articles.filter(a => a.contentful_id === art.cmsId)[0]
              if (tempArt) {
                let tempPayload = {
                  cmsId: tempArt.contentful_id,
                  image: tempArt.imagenPrevisualizacionArticuloParrilla,
                  category: tempArt.categoriasDelArticulo[0].nombreDeLaCategoria,
                  articleType: tempArt.tipoDeArticulo[0].nombreDeLaCategoria,
                  stage: tempArt.etapas[0].nombreDeLaCategoria,
                  title: tempArt.nombreArticulo,
                  date: formatDate(tempArt.fechaDePublicacionDelArticulo),
                  slug: tempArt.etapas[0].slug + tempArt.slug
                }
                newListArticlesSaved.push(tempPayload)
              }
              return null
            })
            localStorage.setItem("SAVED_ARTICLES", JSON.stringify(newListArticlesSaved))
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  useEffect(() => {
    /* if ((window.innerWidth < 1024)) {
      launchPWA()

      const isIOS = !!navigator.platform && /iPhone/.test(navigator.platform)
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

      if (isIOS && isSafari) launchPWAIOS()
    } */

    if (navigator.onLine) {
      handleLoadArticlesSaved()
    }

  }, []);

  useEffect(() => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }, []);


  return (
    <>
      {activeShoppingModal &&
        <ShoppingModal setActiveShoppingModal={setActiveShoppingModal} />
      }
      {/* {activeCookiesToast &&
        <CookiesToast setActiveCookiesToast={setActiveCookiesToast} />
      } */}
      {activeModal &&
        <>{activeModal}</>
      }
      <Header activeMenu={activeMenu} siteTitle={data.site.siteMetadata.title} setActiveShoppingModal={setActiveShoppingModal} />
      <QuickAccessMenu setActiveShoppingModal={setActiveShoppingModal} />
      <ChatModal />
      <div>
        <main className="f-main-container">{children}</main>
        <Footer />
      </div>
    </>
  )
}

export default Layout;